import { render } from "./ResourceCardThumbnail.vue?vue&type=template&id=60847a54"
import script from "./ResourceCardThumbnail.vue?vue&type=script&lang=js"
export * from "./ResourceCardThumbnail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__